export const toggleEye = () => {
  return { type: 'toggle_eye' };
};
export const toggleMenu = () => {
  return { type: 'toggle_menu' };
};
